<template>
  <Drawer
    :placement="placement"
    :closable="false"
    v-model="openGroup"
    draggable
    class="my-drawer"
    width="450"
  >
    <div id="selectMap"></div>
    <div id="selectInput">
      <lySearch
        tishi="请输入地址关键词"
        v-model="searchItem.keyword"
        @search="keywordSearch"
      ></lySearch>
    </div>
    <div id="selectMapList">
      <ul>
        <li
          v-for="(item, index) in addList"
          :key="index"
          @click="clickLi(item)"
        >
          <h4>
            <Tag color="blue">{{ item.distance }}米</Tag>{{ item.name }}
          </h4>
          <p>{{ item.address }}</p>
        </li>
      </ul>
      <ul>
        <li v-for="(item, index) in list1" :key="index" @click="clickLi(item)">
          <h4><Tag color="red">常用标注点</Tag>{{ item.name }}</h4>
          <p>{{ item.address }}</p>
        </li>
      </ul>
      <ul>
        <li v-for="(item, index) in list2" :key="index" @click="clickLi(item)">
          <h4><Tag color="green">卸货</Tag>{{ item.name }}</h4>
          <p>{{ item.address }}</p>
        </li>
      </ul>
    </div>
  </Drawer>
</template>
<script>
var map;
var mouseTool;

export default {
  props: ["address", "placement", "list1", "list2"],
  data() {
    return {
      openGroup: false,
      name_address: "",
      searchItem: {
        keyword: "",
        returnCoord: 2,
      },
      point: {
        x: 114.125348,
        y: 22.673121,
        address: "",
        name: "",
      },
      addList: [],
    };
  },
  methods: {
    gMap() {
      map = new AMap.Map("selectMap", {
        resizeEnable: true,
        zoom: 18,
        center: [this.point.x, this.point.y],
      });
      mouseTool = new AMap.MouseTool(map);
    },
    oldMarker() {
      map.clearMap();
      var marker = new AMap.Marker({
        offset: new AMap.Pixel(-8, -30),
        position: [this.point.x, this.point.y],
        draggable: true,
        cursor: "move",
        raiseOnDrag: true,
      });

      var that = this;
      //拖动后放手
      AMap.event.addListener(marker, "mouseup", function (e) {
        var p = marker.getPosition();
        that.point.x = p.lng;
        that.point.y = p.lat;

        that.zhoubian();
        map.panTo(p);
      });
      marker.setMap(map);
      //map.setFitView();
    },
    openMap() {
      this.openGroup = true;
      setTimeout(() => {
        this.gMap();
      }, 200);
    },
    clear() {
      //this.$emit("update:lng", "");
      //this.$emit("update:lat", "");
      //this.$emit("update:address", "");
      //this.$emit("update:name", "");
    },
    clickLi(v) {
      var obj = {
        address: v.address,
        x: v.x,
        y: v.y,
        name: v.name,
        contact: v.contact,
        tel: v.tel,
      };
      this.$emit("add", obj);
      this.openGroup = false;
    },

    keywordSearch() {
      if (this.searchItem.keyword.length == 0) {
        this.addList = [];
        return;
      }
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.lbs + "/lbs/search",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;

        if (data.length > 0) {
          this.point.x = data[0].x;
          this.point.y = data[0].y;
          this.zhoubian();
        } else {
          this.addList = [];
        }
      });
    },
    zhoubian() {
      var that = this;
      var cpoint = [that.point.x, that.point.y]; //中心点坐标
      AMap.plugin(["AMap.PlaceSearch"], function () {
        //构造地点查询类
        var placeSearch = new AMap.PlaceSearch({
          //type: "餐饮服务", // 兴趣点类别
          pageSize: 10, // 单页显示结果条数
          pageIndex: 1, // 页码
          //city: "010", // 兴趣点城市
          //citylimit: true, //是否强制限制在设置的城市内搜索
          map: map, // 展现结果的地图实例
          //panel: "panel", // 结果列表将在此容器中进行展示。
          //autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        });

        placeSearch.searchNearBy("", cpoint, 500, function (status, result) {
          that.addList = [];
          var data = result.poiList.pois;
          //console.log(data);
          //"http://store.is.autonavi.com/showpic/25969c8ca017495f8066f7033b2cb9de"
          for (const i in data) {
            var obj = {
              address:
                data[i].pname +
                data[i].cityname +
                data[i].adname +
                data[i].address,
              x: data[i].location.lng,
              y: data[i].location.lat,
              name: data[i].name,
              distance: data[i].distance,
            };
            that.addList.push(obj);
          }
          //that.point = that.addList[0];
          that.oldMarker();
        });
      });
    },
  },
  mounted() {},
};
</script>
<style>
#selectMap {
  width: 100%;
  height: 240px;
  background: #f5f5f5;
}
#selectInput {
  width: 100%;
  height: 40px;
}
#selectMapList {
  width: 100%;
  height: calc(100% - 300px);
  overflow: auto;
}
#selectMapList li {
  padding: 10px 0;
  cursor: pointer;
}

#selectMapList li h4 {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 4px;
}
#selectMapList li h4 .ivu-tag {
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/rule/selectMapTool.vue